import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent, SxProps, Theme, useTheme } from '@mui/material'

export interface DropdownProps {
  label?: string
  items: Record<string, string>
  selected: string | null
  onSelect: (item: string, idx?: number | undefined) => void
  error?: false | string
  oneLine?: boolean
  disabled?: boolean
  sx?: SxProps<Theme>
  breakPoints?: number[]
}

/**
 * Display an icon for an appliance type.
 */
export const Dropdown = (props: DropdownProps): JSX.Element => {
  const theme = useTheme()

  const { label, items, selected, disabled, onSelect, oneLine, breakPoints, error } = props

  const sx = {
    ...props.sx
  }

  const onChange = (e: SelectChangeEvent) => {
    onSelect(e.target.value)
  }

  const inputLabel = <InputLabel>{label}</InputLabel>
  const select = <Select
      sx={{ height: '3rem', minWidth: '8rem' }}
      value={['string', 'number'].includes(typeof selected) ? selected as string : ''}
      onChange={onChange}
      data-cy={`dropdown-${label}`}
      size="small"
      disabled={disabled}
    >
      {Object.keys(items).map((item, idx) => {
        return <MenuItem
            key={idx}
            dense
            value={item}
            data-cy={`item-${item}`}
            sx={{
              borderBottom: breakPoints?.includes(idx) ? '1px solid' : '',
              borderColor: breakPoints?.includes(idx) ? 'primary.contrastText' : '',
              py: breakPoints?.includes(idx) ? 1 : 0,
              color: theme.palette.grey[300],
              cursor: 'pointer',
            }}
          >
            {items[item]}
          </MenuItem>
      })
    }
  </Select>

  if (oneLine) {
    return (
      <Box sx={{ ...sx, display: 'flex' }}>
        <Box sx={{ pt: 2 }}>{inputLabel}</Box>
        <Box sx={{ ml: 2 }}>{select}</Box>
      </Box>
    )
  }

  return (
    <Box sx={{ ...sx }}>
      <FormControl>
        {error && <FormHelperText error sx={{ mb: 1 }}>{error}</FormHelperText>}
        {inputLabel}
        {select}
      </FormControl>
    </Box>
  )
}
